export enum Genero {
  MASCULINO = "MASCULINO",
  FEMININO = "FEMININO",
  OUTROS = "OUTROS",
}
